<template>
  <div v-if="selectedOffice" class="mt-6">
    <TpfgMsfEditPage v-if="selectedReport" :id="selectedReport" @change="selectedReport = $event" />
    <TpfgMsfIndexPage @change="selectedReport = $event" v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TpfgMsfEditPage from './TpfgMsfEditPage.vue'
import TpfgMsfIndexPage from './TpfgMsfIndexPage.vue'

export default {
  components: { TpfgMsfEditPage, TpfgMsfIndexPage },
  data () {
    return {
      selectedReport: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  }
}
</script>
